<div class="agent-avatar" *ngIf="!banner">
  <span class="agent-initials"> {{ first }}{{ last }} </span>
</div>

<div class="banner-avatar" *ngIf="banner">
  <emperor-icon name="account_circle" class="banner-icon"> </emperor-icon>
</div>
